import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['item', 'form', 'resetForm', 'done' ]

  connect(){
    const total = this.itemTargets.length
    const answers = []
    let answered = 0

    this.itemTargets.forEach((item, index) => {
      item.addEventListener('traininganswered', (event) => {
        if (answers[index] === undefined) {
          answers[index] = item.dataset.answer
          answered ++
        }
        if (total === answered) {
          this.finish()
        }
      })
    })
  }

  finish() {
    Rails.fire(this.formTarget, 'submit')
    Rails.fire(this.element, 'exercisedone')
    this.doneTarget.classList.remove('d-none')
    this.resetFormTarget.classList.remove('d-none')
    this.element.parentElement.dataset.done = 'true'
  }

  reset(event) {
    Rails.fire(this.element, 'exercisereset')
    const response = event.detail[0]
    this.element.parentNode.innerHTML = response
  }
}
